<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/react.png" /></div>
      <p>React</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/react/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '16.4.0',
        linkList: [
          ur + '16.4.0/cjs/react.development.js',
          ur + '16.4.0/cjs/react.production.min.js',
          ur + '16.4.0/umd/react.development.js',
          ur + '16.4.0/umd/react.production.min.js'
        ]
      }, {
        label: '16.4.0-alpha.0911da3',
        linkList: [
          ur + '16.4.0-alpha.0911da3/cjs/react.development.js',
          ur + '16.4.0-alpha.0911da3/cjs/react.production.min.js',
          ur + '16.4.0-alpha.0911da3/umd/react.development.js',
          ur + '16.4.0-alpha.0911da3/umd/react.production.min.js'
        ]
      }, {
        label: '16.3.2',
        linkList: [
          ur + '16.3.2/cjs/react.development.js',
          ur + '16.3.2/cjs/react.production.min.js',
          ur + '16.3.2/umd/react.development.js',
          ur + '16.3.2/umd/react.production.min.js'
        ]
      }, {
        label: '16.3.1',
        linkList: [
          ur + '16.3.1/cjs/react.development.js',
          ur + '16.3.1/cjs/react.production.min.js',
          ur + '16.3.1/umd/react.development.js',
          ur + '16.3.1/umd/react.production.min.js'
        ]
      }, {
        label: '16.3.0',
        linkList: [
          ur + '16.3.0/cjs/react.development.js',
          ur + '16.3.0/cjs/react.production.min.js',
          ur + '16.3.0/umd/react.development.js',
          ur + '16.3.0/umd/react.production.min.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListReact.vue